import React from 'react'

const ArchiveBlackIcon = () => {
  return (
    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M13.9997 2.5H1.99967C1.63148 2.5 1.33301 2.79848 1.33301 3.16667V5.16667C1.33301 5.53486 1.63148 5.83333 1.99967 5.83333H13.9997C14.3679 5.83333 14.6663 5.53486 14.6663 5.16667V3.16667C14.6663 2.79848 14.3679 2.5 13.9997 2.5Z" stroke="black" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M2.66699 5.83594V13.1693C2.66699 13.5229 2.80747 13.862 3.05752 14.1121C3.30756 14.3621 3.6467 14.5026 4.00033 14.5026H12.0003C12.3539 14.5026 12.6931 14.3621 12.9431 14.1121C13.1932 13.862 13.3337 13.5229 13.3337 13.1693V5.83594" stroke="black" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M6.66699 8.5H9.33366" stroke="black" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
    </svg>

  )
}

export default ArchiveBlackIcon
